export default __webpack_public_path__ + "static/bbs-9d29f0a69c2bb304d8752801085771ca.webp";